import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import TabPanel from "@mui/lab/TabPanel";
import { Grid } from "@mui/material";
import Information from "./Information";
import { userServices } from "../../../service/UserService";
import ListCV from "./ListCV";
import { useLocation, useNavigate } from "react-router-dom";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import AssociationInfo from "../mes_association/AssociationInfo";

export default function Profile() {
  const [userInfo, setUserInfo] = React.useState({});
  const location = useLocation();
  const [loadingPage, setLoadingPage] = React.useState(false);
  const [loadUserInfo, setLoadUserInfo] = React.useState(false);
  const [tabsChargee, setTabChargee] = React.useState([]);
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const tab_value = query.get("tab") || "0";

  const createContenus = (userInfo) => {
    const tabs = [
      {
        title: userInfo.is_association !== "0" ? "Gerant" : "Information",
        content: (
          <Information
            loading={loadingPage}
            user_info={userInfo}
            reload={() => handleFetchUserInfo(true)}
          />
        ),
        icon: <PermIdentityOutlinedIcon />,
        idx: "1",
      },
    ];

    if (userInfo.is_association === "0") {
      tabs.push({
        title: "CV",
        content: <ListCV />,
        icon: <AssignmentIndOutlinedIcon />,
        idx: "2",
      });
    } else {
        tabs.push({
          title: "Information de l'Agence/Association",
          content: <AssociationInfo />,
          icon: <Groups2OutlinedIcon />,
          idx: "3",
        });
    }

    return tabs;
  };

  const handleFetchUserInfo = (tabs = true) => {
    setLoadingPage(true);
    const curr_tab = "0";
    setLoadUserInfo(true);
    userServices
      .getMyProfile()
      .then((res) => {
        if (res && res.success) {
          setUserInfo(res.data);
          setTabChargee((prev) => [...prev, curr_tab]);
        }
      })
      .finally(() => {
        setLoadUserInfo(false);
        setLoadingPage(false);
      });
  };

  React.useEffect(() => {
    handleFetchUserInfo();
  }, []);

  const handleChange = (event, newValue) => {
    query.set("tab", newValue);
    navigate(`?${query.toString()}`);
  };

  const [contenus, setContenus] = React.useState([]);

  React.useEffect(() => {
    setContenus(createContenus(userInfo));
  }, [userInfo]);

  return (
    <Grid container /* width={"100vw"} */>
      <Grid item xs={12}>
        <TabContext value={tab_value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              {contenus.map((item, index) => (
                <Tab
                  key={index}
                  label={item.title}
                  icon={item.icon}
                  iconPosition="start"
                  value={index.toString()}
                />
              ))}
            </TabList>
          </Box>
          <Grid item>
            {contenus.map((item, index) => (
              <TabPanel key={index} value={index.toString()}>
                {item.content}
              </TabPanel>
            ))}
          </Grid>
        </TabContext>
      </Grid>
    </Grid>
  );
}
